import styled from 'styled-components';

import {colors} from '@app/styles/theme';

export const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
`;

export const ControlsCard = styled.div`
    display: flex;
    align-items: center;
    gap: 16px;
    padding: 16px;
    background: ${colors.white};
    box-shadow: 0 0 2px 0 rgba(0, 0, 0, 0.15);
    flex-wrap: wrap;
`;

export const FilterBox = styled.div`
    flex: 1 1 240px;
    max-width: 320px;
`;

export const Actions = styled.div`
    margin-left: auto;
`;
